import { render, staticRenderFns } from "./ModalSearchPostcode.vue?vue&type=template&id=53715e90&"
import script from "./ModalSearchPostcode.vue?vue&type=script&lang=js&"
export * from "./ModalSearchPostcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports